import React from 'react';

const blogPosts = [
  { title: "Build Stunning Travel Itineraries in Seconds with Our Itinerary Builder", excerpt: "If you run a travel agency, you know the struggle: creating itineraries can eat up hours of your time...", date: "2025-08-29" },
  { title: "One Search, Endless Travel Options: The Power of Search & Compare", excerpt: "Travelers today are smarter, faster, and more demanding than ever...", date: "2025-08-29" },
  { title: "Transform Customer Engagement with an AI WhatsApp Chatbot", excerpt: "In today’s digital-first world, travelers don’t want to wait for answers—they expect instant responses...", date: "2025-08-29" },
  { title: "Give Your Travel Agency a Digital Makeover with a Ready-to-Use Website", excerpt: "In today’s travel industry, customers start their journey online...", date: "2025-08-29" },
  { title: "Turn Likes into Bookings: Social Media Lead Generation for Travel Agencies", excerpt: "Every day, millions of people scroll through Facebook, Instagram, and TikTok...", date: "2025-08-29" },
  { title: "Take Control of Your Business with Powerful Analytics and Reporting", excerpt: "Running a travel agency isn’t just about booking flights and hotels—it’s about managing people, payments, and performance...", date: "2025-08-29" },
];

export default function BlogPage() {
  return (
     <section className="py-5" style={{ backgroundColor: '#F8F9FA' }}>
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <h1 className="display-4 fw-bold">Latest Blogs & Insights</h1>
            <p className="lead text-muted">Stay up to date with the newest articles, tutorials, and news.</p>
          </div>
        </div>
        <div className="row">
            {blogPosts.map((post, index) => (
                <div className="col-lg-4 col-md-6 mb-4" key={index}>
                    <div className="card h-100 border-0 shadow-sm">
                        <div className="card-body">
                            <small className="text-muted">{post.date}</small>
                            <h5 className="card-title fw-bold my-2">{post.title}</h5>
                            <p className="card-text text-muted">{post.excerpt}</p>
                        </div>
                        <div className="card-footer bg-white border-0">
                             <a href="#!" className="text-decoration-none fw-semibold">Read more <i className="ri-arrow-right-line align-middle"></i></a>
                        </div>
                    </div>
                </div>
            ))}
        </div>
      </div>
    </section>
  );
}